import { useNotifications } from "@faire/deprecated-retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useNotifications";
import { useMemo } from "react";

export const useHasOnlyDismissedHighPriorityNotifications = () => {
  const { notifications } = useNotifications();
  return useMemo(
    () =>
      notifications
        ?.filter(({ priority }) => priority === "HIGH")
        .some(({ nudge_dismissed_at }) => !!nudge_dismissed_at) ?? false,
    [notifications]
  );
};
